<template>
  <Modal
    :value="isShow"
    :title="$t('other.w148')"
    :mask-closable="false"
    :closable="false"
    width="720"
  >
    <div>
      <p>{{ $t("other.w149") }}</p>
      <p>{{ $t("other.w150") }}</p>
      <p class="p1">{{ $t("other.w140") }}</p>
      <p>{{ $t("other.w141") }}</p>
      <p class="p1">{{ $t("other.w142") }}</p>
      <p class="p1">{{ $t("other.w143") }}</p>
      <p class="p1">{{ $t("other.w144") }}</p>
      <p class="p1 p2">{{ $t("other.w145") }}</p>
    </div>
    <template slot="footer">
      <Button type="primary" class="bindBtn" :disabled="isFlag" @click="toOk">
        <span v-if="isFlag">({{ value }}s)</span>
        <span>{{ $t("other.w147") }}</span>
      </Button>
      <div class="nos">
         <Checkbox v-model="single" @on-change='onChange' :disabled="isFlag">不再提醒</Checkbox>
      </div>
    </template>
  </Modal>
</template>
<script>
import { notices } from "@/libs/sysconst";
export default {
  data() {
    return {
      notices, //需要弹出得路由
      timer: "",
      value: "3",
      isFlag: true,
      single:false
    };
  },
  mounted() {},
  methods: {
    onChange(v){
      console.log(v)
      if(v){
        this.$axios.post("/Member/RZJProfile/CloseInvestTip").then(res=>{
          if(!res.err){
             this.toOk()
          }
        })
      }
    },
    init() {
      this.value = "3";
      this.isFlag = true;
      this.timer = setInterval(() => {
        this.value--;
        if (this.value == 0) {
          clearInterval(this.timer);
          this.isFlag = false;
        }
      }, 1000);
    },
    toOk() {
      this.$store.commit("user/closeValid", false);
      this.$store.dispatch("user/getSafe");
      let arrId = JSON.parse(localStorage.getItem("arrid")) || [];
      let a = false;
      arrId.map((o) => {
        if (o.id == this.safe.Id) {
          a = true;
        }
      });
      if (!a) {
        arrId.push(this.safe.Id);
      }
      localStorage.setItem("arrid", JSON.stringify(arrId));
    },
  },
  computed: {
    safe() {
      return this.$store.state.user.safe;
    },
    isShow() {
      let c = this.$store.state.user.show;
      if (c) {
        this.init();
      }
      return c;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.ivu-modal-header {
  .ivu-modal-header-inner {
    font-size: 14px !important;
  }
}
/deep/.ivu-modal-body {
  padding-top: 10px !important;
  p {
    font-size: 14px !important;
    line-height: 24px !important;
  }
}
/deep/ .ivu-modal-footer {
  text-align: center;
}
.p1 {
  text-indent: 2em;
}
.p2 {
  margin-top: 20px;
}
.nos{
  margin-top: 15px;
}
</style>
